import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'transformCurrency'
})
export class TransformCurrencyPipe implements PipeTransform {

    transform(input: any): any {
        switch (input) {
            case 'PEN':
                input = 'Soles';
                break;
            case 'USD':
                input = 'Dolares Americanos';
                break;
            case 'EUR':
                input = 'Euros';
                break;
            case 'GBP':
                input = 'Libras Esterlinas';
                break;
        }


        return input;
    }

}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/pipes/string/transformCurrency.pipe.ts